import { StatCard } from '../components/dashboard/stat-card'
import { EnhancedScheduleCard } from '../components/dashboard/enhanced-schedule-card'
import { AlertsCard } from '../components/dashboard/alerts-card'
import { useClinicSettings } from '../lib/store/clinic-settings'
import {
  Activity,
  Calendar,
  Package,
  Users,
} from 'lucide-react'

export function Dashboard() {
  const { clinicName } = useClinicSettings()

  return (
    <div className="space-y-6 max-w-[1400px] mx-auto">
      {clinicName && (
        <h1 className="text-4xl font-bold text-blue-600 dark:text-blue-400">{clinicName}</h1>
      )}
      <div className="flex justify-between items-center">
        <div>
          <h2 className="text-2xl font-semibold text-foreground">Dashboard Overview</h2>
          <p className="text-sm text-muted-foreground mt-1">Welcome back, Dr. Smith</p>
        </div>
        <div className="text-sm text-muted-foreground">
          Last updated: 5 minutes ago
        </div>
      </div>

      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-4">
        <StatCard
          title="Total Patients"
          value="1,234"
          subtitle="Active patients"
          icon={Users}
          variant="primary"
        />
        <StatCard
          title="Today's Visits"
          value="24"
          subtitle="4 in progress"
          icon={Activity}
          variant="success"
        />
        <StatCard
          title="Upcoming Visits"
          value="12"
          subtitle="Next in 2 hours"
          icon={Calendar}
          variant="warning"
        />
        <StatCard
          title="Low Stock Items"
          value="7"
          subtitle="Requires attention"
          icon={Package}
          variant="danger"
        />
      </div>

      <div className="grid gap-6 lg:grid-cols-2">
        <EnhancedScheduleCard />
        <AlertsCard />
      </div>
    </div>
  )
}
